<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <v-card class="mx-auto pa-3 mb-3" max-width="800" outlined>
      <div class="d-flex justify-space-between align-center">
        <div class="text-h6">{{ (sponsorship.id)? `Available Seat: ${sponsorship.availableSeat} | ${$moment(sponsorship.timestampStart).format("DD MMM YYYY hh:mm A")} - ${$moment(sponsorship.timestampEnd).format("DD MMM YYYY hh:mm A")}` : '• • •' }}</div>
      </div>
    </v-card>
    <!-- <ShareLink type="institution" :id="this.$route.params.parentId"></ShareLink> -->
    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row>
        <v-col><h2>Students</h2></v-col>
        <v-col class="text-right">
          <v-btn
            rounded
            :disabled="sponsorship.availableSeat == 0 || $moment(sponsorship.timestampEnd) < $moment()"
            :to="{
              name: 'PageEducatorInstitutionSponsorshipStudentAdd',
              params: { parentId: this.$route.params.parentId,id: this.$route.params.id },
            }"
            color="primary"
          >
            + Add Student
          </v-btn>
          <!-- <v-btn
          class="ml-2"
            rounded
            :to="{
              name: 'PageEducatorInstitutionClassroomStudentAdd',
              params: { parentId: this.$route.params.parentId,id: this.$route.params.id },
            }"
            color="primary"
          >
            + New Student
          </v-btn> -->
        </v-col>
      </v-row>
      <v-card-title></v-card-title>
     <!-- BOC:[tabs] -->
        <ListAll :url="`${$api.servers.sso}/api/v1/${$_getLocale()}/educator/institution/${$route.params.parentId}/sponsorship/${$route.params.id}/student`" :headers="headers" :callbackClick="clickRead"></ListAll>
    <!-- EOC -->
    </v-card>
  </v-container>
</template>
    
    <script>
import { mapState } from "vuex";
import ListAll from "../../components/Datatable/ListAll.vue";
// import ShareLink from "../../components/Dashboard/ShareLink.vue";
export default {
  components: {
    ListAll,
    // ShareLink
    //
  },
  computed: {
    size() {
      const size = { xs: "small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  // computed: mapState({
  //     auth: (state) => state.auth.data,
  //   }),
  props: [
    //
  ],
  data: () => ({
    tab: null,
    tabs: [
      {
        key: "active",
        label: "Active",
      },
      {
        key: "inactive",
        label: "Inactive",
      },
    ],
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    url: null,
    sponsorship:{},
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    headers: [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "index",
      },
      { text: "Avatar", value: "avatar" },
      { text: "Name", value: "name" },
      { text: "Classroom", value: "Classroom.name" },
      // { text: "", value: "button", align: "end" },
    ],
  }),
  created() {
    //BOC:[breadcrumbs]
    this.breadcrumbs = [
      {
        text: "Dashboard",
        to: { name: "PageEducatorDashboard" },
        exact: true,
      },
      {
        text: "My Institution",
        to: {
          name: "PageEducatorInstitutionDashboard",
          params: { id: this.$route.params.parentId },
        },
        exact: true,
      },
      {
        text: "Sponsorships",
        to: {
          name: "PageEducatorInstitutionSponsorship",
          params: { id: this.$route.params.parentId },
        },
        exact: true,
      },
      {
        text: "Students",
        to: { name: "PageEducatorInstitutionSponsorshipStudent" },
        exact: true,
      },
    ];
    //EOC
    this.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/educator/institution/"+this.$route.params.parentId+"/classroom/" +
      this.$route.params.id +
      "/student";

      this.api.method = "GET";
    this.api.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
       "/educator/institution/"+this.$route.params.parentId+"/sponsorship/" +
      this.$route.params.id;

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };

    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };

    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.sponsorship = resp
    
    };
  },
  mounted() {
    this.$api.fetch(this.api);
  },
  methods: {
    // updateBreadcrumb(resp) {
    //   this.breadcrumbs.push({
    //     text: "Dashboard",
    //     to: { name: "PageEducatorDashboard" },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //     text: resp.Institution.name,
    //     to: { name: "PageEducatorInstitutionDashboard",params:{id:this.$route.params.parentId} },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //     text: 'Classrooms',
    //     to: { name: "PageEducatorInstitutionClassroom",params:{id:this.$route.params.parentId} },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //     text: resp.name,
    //     to: { name: "PageEducatorInstitutionClassroomDashboard" ,params:{id:this.$route.params.id,parentId:this.$route.params.parentId}},
    //     exact: true,
    //   });

    //   this.breadcrumbs.push({
    //   text: "Students",
    //   to: { name: "PageEducatorInstitutionClassroomStudent" },
    //   exact: true,
    // });
    // },
    // clickRead(item) {
    //   this.$router.push({
    //     name: "PageEducatorInstitutionClassroomStudentRead",
    //     params: {grandparentId: this.$route.params.parentId, parentId: this.$route.params.id, id: item.id },
    //   });
    // },
  },
};
</script>
<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}
.form-content {
  width: 600px !important;
}
</style>